// src/features/boe/components/programs/Program1300.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_1300_CONFIG = {
  fullName: "FOREIGN LANGUAGE & ELL",
  docId: "1300",

  fieldDefs: [
    // POSITIONS (FTE)
    {
      key: "positionsAdmin",
      label: "Positions – Administrative",
      valueType: "count",
      sources: [{ block: "Positions", key: "Administrative" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsTeachers",
      label: "Positions – Teachers",
      valueType: "count",
      sources: [{ block: "Positions", key: "Teachers" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsTeachersEllMl",
      label: "Positions – Teachers (ELL / ML)",
      valueType: "count",
      sources: [
        { block: "Positions", key: "Teachers (ELL)" },
        { block: "Positions", key: "Teachers (ML)" },
        { block: "Positions", key: "Teachers (MLL)" },
      ],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsTeachersFlGrant",
      label: "Positions – Teachers F.L. ACTFL Grant",
      valueType: "count",
      sources: [{ block: "Positions", key: "Teachers - F.L. ACTFL Grant" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsTeachersConfucius",
      label: "Positions – Teachers – Confucius Classroom",
      valueType: "count",
      sources: [{ block: "Positions", key: "Teachers - Confucius Classroom" }],
      group: "positions",
      defaultVisible: false,
    },

    // SALARIES
    {
      key: "salariesAdmin",
      label: "Salaries – Administrative",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Administrative" },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesTeachers",
      label: "Salaries – Teachers",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Teachers" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesTeachersEllMl",
      label: "Salaries – Teachers (ELL / ML)",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Teachers (ELL)" },
        { block: "Salaries", key: "Teachers (ML)" },
        { block: "Salaries", key: "Teachers (MLL)" },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesForeignLangSupv",
      label: "Salaries – Foreign Language Supv.",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Foreign Language Supv." }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesForeignLangAssistant",
      label: "Salaries – Foreign Language Assistant",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Foreign Language Assistant" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesTutorsEllMl",
      label: "Salaries – Tutors (ELL / ML)",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Tutors (ELL)" },
        { block: "Salaries", key: "Tutors (ML)" },
        { block: "Salaries", key: "Tutors (MLL)" },
      ],
      group: "salaries",
      defaultVisible: false,
    },

    // FIELD TRIPS – General
    {
      key: "fieldTrips",
      label: "Field Trips",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Field Trips" },
        { block: "Purchased Services", key: "Field Trips" },
      ],
      group: "salaries",
      defaultVisible: false,
    },

    // FIELD TRIPS – ELL / ML
    {
      key: "fieldTripsEllMl",
      label: "Field Trips (ELL / ML)",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Field Trips (ELL)" },
        { block: "Salaries", key: "Field Trips (ML)" },
        { block: "Salaries", key: "Field Trips (MLL)" },
        { block: "Purchased Services", key: "Field Trips (ELL)" },
        { block: "Purchased Services", key: "Field Trips (ML)" },
        { block: "Purchased Services", key: "Field Trips (MLL)" },
      ],
      group: "salaries",
      defaultVisible: false,
    },

    // PURCHASED SERVICES
    {
      key: "purchasedNationalCompetition",
      label: "National Competition",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "National Competition" }],
      group: "purchasedServices",
      defaultVisible: false,
    },
    {
      key: "purchasedSpeakersArtists",
      label: "Resource Speakers / Artists",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "Resource Speakers / Artists" },
        { block: "Purchased Services", key: "Resource Speakers/Artists" },
      ],
      group: "purchasedServices",
      defaultVisible: false,
    },
    {
      key: "purchasedInterpreterServices",
      label: "Interpreter Services",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Interpreter Services" }],
      group: "purchasedServices",
      defaultVisible: false,
    },

    // SUPPLIES / MATERIALS
    {
      key: "instructionalMaterials",
      label: "Instructional Materials",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Instructional Materials" },
      ],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "instructionalMaterialsEllMl",
      label: "Instructional Materials (ELL / ML)",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Instructional Materials (ELL)" },
        { block: "Supplies / Materials", key: "Instructional Materials (ML)" },
        { block: "Supplies / Materials", key: "Instructional Materials (MLL)" },
      ],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "technologySoftware",
      label: "Technology – Software",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Technology Software" },
        { block: "Supplies / Materials", key: "Technology - Software" },
      ],
      group: "materials",
      defaultVisible: false,
    },

    // OTHER
    {
      key: "duesFees",
      label: "Dues / Fees",
      valueType: "currency",
      sources: [
        { block: "Other", key: "Dues and Fees" },
        { block: "Other", key: "Dues/Fees" },
        { block: "Other", key: "Dues / Fees" },
      ],
      group: "other",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "approved",
      title: "Approved Budget",
      sectionKey: "Approved",
      fields: [
        "positionsAdmin",
        "positionsTeachers",
        "positionsTeachersEllMl",
        "salariesAdmin",
        "salariesTeachers",
        "salariesTeachersEllMl",
        "salariesForeignLangSupv",
        "salariesForeignLangAssistant",
        "salariesTutorsEllMl",
        "fieldTrips",
        "fieldTripsEllMl",
        "purchasedNationalCompetition",
        "purchasedSpeakersArtists",
        "purchasedInterpreterServices",
        "instructionalMaterials",
        "instructionalMaterialsEllMl",
        "technologySoftware",
        "duesFees",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "130px" },
        positionsTeachers: { minWidth: "120px" },
        positionsTeachersEllMl: { minWidth: "140px" },

        // Salaries
        salariesAdmin: { minWidth: "130px" },
        salariesTeachers: { minWidth: "120px" },
        salariesTeachersEllMl: { minWidth: "140px" },
        salariesForeignLangSupv: { minWidth: "150px" },
        salariesForeignLangAssistant: { minWidth: "170px" },
        salariesTutorsEllMl: { minWidth: "140px" },

        fieldTrips: { minWidth: "90px" },
         fieldTripsEllMl: { minWidth: "90px" },

        // Purchased Services
        purchasedNationalCompetition: { minWidth: "150px" },
        purchasedSpeakersArtists: { minWidth: "180px" },
        purchasedInterpreterServices: { minWidth: "160px" },

        // Materials
        instructionalMaterials: { minWidth: "140px" },
        instructionalMaterialsEllMl: { minWidth: "170px" },
        technologySoftware: { minWidth: "150px" },

        // Other
        duesFees: { minWidth: "120px" },
      },
    },
    {
      id: "actual",
      title: "Actual Spending",
      sectionKey: "Actual",
      fields: [
        "positionsAdmin",
        "positionsTeachers",
        "positionsTeachersEllMl",
        "salariesAdmin",
        "salariesTeachers",
        "salariesTeachersEllMl",
        "salariesForeignLangSupv",
        "salariesForeignLangAssistant",
        "salariesTutorsEllMl",
        "fieldTrips",
                "fieldTripsEllMl",
        "purchasedNationalCompetition",
        "purchasedSpeakersArtists",
        "purchasedInterpreterServices",
        "instructionalMaterials",
        "instructionalMaterialsEllMl",
        "technologySoftware",
        "duesFees",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "130px" },
        positionsTeachers: { minWidth: "120px" },
        positionsTeachersEllMl: { minWidth: "140px" },

        // Salaries
        salariesAdmin: { minWidth: "130px" },
        salariesTeachers: { minWidth: "120px" },
        salariesTeachersEllMl: { minWidth: "140px" },
        salariesForeignLangSupv: { minWidth: "150px" },
        salariesForeignLangAssistant: { minWidth: "170px" },
        salariesTutorsEllMl: { minWidth: "140px" },

        fieldTrips: { minWidth: "90px" },
                 fieldTripsEllMl: { minWidth: "90px" },

        // Purchased Services
        purchasedNationalCompetition: { minWidth: "150px" },
        purchasedSpeakersArtists: { minWidth: "180px" },
        purchasedInterpreterServices: { minWidth: "160px" },

        // Materials
        instructionalMaterials: { minWidth: "140px" },
        instructionalMaterialsEllMl: { minWidth: "170px" },
        technologySoftware: { minWidth: "150px" },

        // Other
        duesFees: { minWidth: "120px" },
      },
    },
  ],
};

export function Program1300(props) {
  return (
    <ProgramBudget programId="1300" config={PROGRAM_1300_CONFIG} {...props} />
  );
}
